import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  max-height: 600px;
  background: #F7F7F7;
  border-radius: 15px;
  overflow: hidden;
  padding: 10px;
  justify-content: center;
  align-items: center;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
`

export const FormField = styled(Container)`
  width: 100%;
  justify-content: flex-end;
  padding: 0px;
  margin-bottom: 10px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
`

export const Message = styled(Row)`
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const ButtonText = styled(SubTitle)`
  color: #FFFFFF;
  margin: 0px;
  font-weight: 200;
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const Button = styled(LookButton).attrs(buttonLook({ variant: 'primary' }))`
  width: 140px;
  align-self: center;
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`
